import { NotificationResource, useNotificationsCommon, UseNotificationsCommonInput } from '@eih-netbroker/common';
import { useMemo } from 'react';
import { useResource, useResourceHeaders } from '../../../shared/services/useResource';
import { store } from '../../../shared/state/store';
import { useLogger } from '../../../shared/utils/useLogger';

export const useNotification = () => {
  const { getResourceHeaderWithToken } = useResourceHeaders();
  const notificationResource = useResource(NotificationResource);
  const logger = useLogger('useNotification');
  const p = useMemo(
    (): UseNotificationsCommonInput => ({
      notificationResource,
      getResourceHeaderWithToken,
      logger,
      store,
    }),
    [logger, notificationResource, getResourceHeaderWithToken],
  );
  return useNotificationsCommon(p);
};
